import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { useStarterDashboardTabExperiment } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { PromoteYourPetition } from './components/PromoteYourPetition';
import { ShareVisual } from './components/ShareVisual';
import { ShareYourPetition } from './components/ShareYourPetition';
import { ShareYourPetitionOffline } from './components/ShareYourPetitionOffline';
import { useGrowPetition } from './hooks/useGrowPetition';

export function GrowPetition(): JSX.Element {
	const { data } = useGrowPetition();
	const {
		data: { variant },
	} = useStarterDashboardTabExperiment();

	return (
		<Box as="section" role="group" aria-labelledby="grow-petition-title" mb={variant === 'control' ? [32, 48] : 0}>
			{variant === 'control' && (
				<Heading as="h2" size={['h4', 'h3']} id="grow-petition-title">
					<Translate value="corgi.petition.starter_dashboard.grow_petition.title" />
				</Heading>
			)}
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: ['1fr', '1fr 1fr'],
					gridGap: variant === 'control' ? [16, 24] : 16,
				}}
			>
				<ShareYourPetition />
				<ShareYourPetitionOffline />
				<Box sx={{ gridColumn: ['1/1', '1/3'] }}>
					<ShareVisual />
				</Box>
				{data.shouldShowPromoteYourPetition && (
					<Box sx={{ gridColumn: ['1/1', '1/3'] }}>
						<PromoteYourPetition />
					</Box>
				)}
			</Box>
		</Box>
	);
}
